module.exports = __webpack_public_path__ + "img/news_trplus_hover.bc797190.svg";